import {
  BannerOutdoorDesktop,
  BannerOutdoorMobile,
  BannerOutdoorTablet,
  BannerRtlsDesktop,
  BannerRtlsMobile,
  BannerRtlsTablet,
  BannerVideoDesktop,
  BannerVideoMobile,
  BannerVideoTablet,
  HomeAccess1D,
  HomeAccess1M,
  HomeAccess1T,
  HomeAccess2D,
  HomeAccess2M,
  HomeAccess2T,
  HomeAccess3D,
  HomeAccess3M,
  HomeAccess3T,
  HomeAccess4D,
  HomeAccess4M,
  HomeAccess4T,
  HomeAccess5D,
  HomeAccess5M,
  HomeAccess5T,
  HomeBeacon1D,
  HomeBeacon1M,
  HomeBeacon1T,
  HomeBeacon2D,
  HomeBeacon2M,
  HomeBeacon2T,
  HomeBeacon3D,
  HomeBeacon3M,
  HomeBeacon3T,
  HomeBeacon4D,
  HomeBeacon4M,
  HomeBeacon4T,
  HomeBeacon5D,
  HomeBeacon5M,
  HomeBeacon5T,
  HomeBeacon6D,
  HomeBeacon6M,
  HomeBeacon6T,
  HomeProductAoaDesktop,
  HomeProductAoaMobile,
  HomeProductAoaTablet,
  HomeProductBleDesktop,
  HomeProductBleMobile,
  HomeProductBleTablet,
  HomeProductComfortDesktop,
  HomeProductComfortMobile,
  HomeProductComfortTablet,
  HomeProductEdgeDesktop,
  HomeProductEdgeMobile,
  HomeProductEdgeTablet,
  HomeProductServerDesktop,
  HomeProductServerMobile,
  HomeProductServerTablet,
  HomeProductUwbDesktop,
  HomeProductUwbMobile,
  HomeProductUwbTablet,
  HomeRTLS1D,
  HomeRTLS1M,
  HomeRTLS1T,
  HomeRTLS2D,
  HomeRTLS2M,
  HomeRTLS2T,
  HomeRTLS3D,
  HomeRTLS3M,
  HomeRTLS3T,
  HomeSolution1D,
  HomeSolution1M,
  HomeSolution1T,
  HomeSolution2D,
  HomeSolution2M,
  HomeSolution2T,
  HomeSolution3D,
  HomeSolution3M,
  HomeSolution3T,
  HomeSolution4D,
  HomeSolution4M,
  HomeSolution4T,
  HomeSolutionLandConstruction,
  HomeSolutionLandLogistics,
  HomeSolutionLandManufacture,
  HomeSolutionLandMedical,
  HomeSolutionLandOffice,
  HomeSolutionLandRetail,
  HomeSolutionPortConstruction,
  HomeSolutionPortLogistics,
  HomeSolutionPortManufacture,
  HomeSolutionPortMedical,
  HomeSolutionPortOffice,
  HomeSolutionPortRetail,
} from '@assets/images/main/home';
import { HomeDTBanner } from '@assets/images/main/home/dt';

export default {
  titleBanner: {
    title: '위치추적과 디지털트윈 전문 플랫폼',
    description: '실시간 위치추적, 출입 시스템, 디지털트윈, 산업용 IoT가 가져오는 공간의 혁신',
  },

  productText: {
    title: `디지털트윈, 위치추적 제품`,
    description: `변화를 찾는 당신에게 오브로가 제안하는 새로움`,
  },

  banner: {
    productCard: [
      {
        title: '실내 위치추적',
        desc: 'BLE, AoA, UWB 등 무선 통신 기반 위치 추적',
        link: '/rtls',
        bgImg: {
          desktop: BannerRtlsDesktop,
          tablet: BannerRtlsTablet,
          mobile: BannerRtlsMobile,
        },
      },
      {
        title: '영상 위치추적',
        desc: 'AI 기반 영상을 통한 객체 추적',
        link: '/camera',
        bgImg: {
          desktop: BannerVideoDesktop,
          tablet: BannerVideoTablet,
          mobile: BannerVideoMobile,
        },
      },
      {
        title: '야외 위치추적',
        desc: '차량 및 야드 위치추적',
        link: '/outdoor',
        bgImg: {
          desktop: BannerOutdoorDesktop,
          tablet: BannerOutdoorTablet,
          mobile: BannerOutdoorMobile,
        },
      },
    ],
  },

  os: {
    title: '위치추적기반 디지털 트윈 플랫폼',
    desc: 'ORBRO OS는 현실의 공간을 가상의 화면에서 구현합니다.<br/>실시간으로 빠르고 정확한 데이터를 수집하여 편의성을 제공합니다.',
  },

  rtls: {
    title: '모든 현장에 적용 가능한 위치추적 라인업',
    desc: '블루투스, UWB통신을 이용한 전파 위치추적과 영상과 AI기술을 이용한 위치추적 라인업을 제공합니다.',

    card: [
      {
        tag: '실시간 위치추적',
        title: '현실을 가상 공간에서',
        link: 'https://orbro.io/rtls',
        img: {
          desktop: HomeRTLS1D,
          tablet: HomeRTLS1T,
          mobile: HomeRTLS1M,
        },
      },
      {
        title: '비콘을 통한 위치 추적',
        desc: 'BLE를 통한 위치 추적 시스템',
        link: 'https://orbro.io/beacon/ble',
        img: {
          desktop: HomeRTLS2D,
          tablet: HomeRTLS2T,
          mobile: HomeRTLS2M,
        },
      },
      {
        title: 'AI 카메라를 통한 위치추적',
        desc: 'AI기술을 활용한 위치추적 및 이상행동 감지',
        link: 'https://orbro.io/camera',
        img: {
          desktop: HomeRTLS3D,
          tablet: HomeRTLS3T,
          mobile: HomeRTLS3M,
        },
      },
    ],
  },

  access: {
    title: '모바일을 이용한 자연스러운 비접촉 출입',
    desc: '모바일, 얼굴인식 기술을 이용한 차세대 출입방식과 정보를 제공합니다.',

    card: [
      {
        tag: '다양한 출입 방식 제공',
        title: 'NFC/Bluetooth/스마트폰<br/>모든 방식의 출입',
        sub: 'NFC카드 출입은 물론,<br/>모바일 출입, 스마트 워치 출입까지 가능합니다.',
        img: {
          desktop: HomeAccess1D,
          tablet: HomeAccess1T,
          mobile: HomeAccess1M,
        },
      },
      {
        title: 'Access Pro',
        link: 'https://orbro.io/access/pro',
        desc: '얼굴인식, NFC카드, 모바일 모든 출입 방식을 지원',
        img: {
          desktop: HomeAccess2D,
          tablet: HomeAccess2T,
          mobile: HomeAccess2M,
        },
      },
      {
        title: 'Access Auto',
        link: 'https://orbro.io/access/auto',
        desc: '모바일 출입의 최적화',
        img: {
          desktop: HomeAccess3D,
          tablet: HomeAccess3T,
          mobile: HomeAccess3M,
        },
      },
      {
        title: '액세서리',
        desc: '다양한 출입 액세서리 제공',
        link: 'https://orbro.io/access/accessory',
        img: {
          desktop: HomeAccess4D,
          tablet: HomeAccess4T,
          mobile: HomeAccess4M,
        },
      },
      {
        title: 'Access Lite',
        desc: '기본에 충실한 모바일 출입 시스템과 NFC, 애플워치 지원',
        tag: '출시예정',
        img: {
          desktop: HomeAccess5D,
          tablet: HomeAccess5T,
          mobile: HomeAccess5M,
        },
      },
    ],
  },

  dt: {
    title: '세계최초 3세대 디지털 전환<br/>디지털트윈 전문 플랫폼',
    desc: '오브로의 디지털트윈 솔루션으로 도시를 가상으로 구현하며, 한층 더 진화된 혁신을 체험해보세요.',
    img: HomeDTBanner,
  },

  beacon: {
    title: '산업용 IoT 및 비콘 시스템',
    desc: '산업 현장에서 요구되는 다양한 센서 및 비콘 시스템으로 효율적인 작업 환경을 조성합니다.',

    card: [
      {
        title: 'ALESS-GW',
        desc: 'LoRA 게이트웨이',
        link: 'https://orbro.io/iot/LoRAGateway',
        img: {
          desktop: HomeBeacon1D,
          tablet: HomeBeacon1T,
          mobile: HomeBeacon1M,
        },
      },
      {
        title: 'ALESS-BA',
        desc: 'LoRA통신을 이용한 산업용 센서',
        link: 'https://orbro.io/iot/LoRASensor',
        img: {
          desktop: HomeBeacon2D,
          tablet: HomeBeacon2T,
          mobile: HomeBeacon2M,
        },
      },
      {
        title: 'VENTAX CO+',
        desc: '일산화탄소 측정기',
        link: 'https://orbro.io/iot/co2',
        img: {
          desktop: HomeBeacon3D,
          tablet: HomeBeacon3T,
          mobile: HomeBeacon3M,
        },
      },
      {
        title: 'VENTAX',
        desc: '공기 품질 측정기',
        link: 'https://orbro.io/iot/air',
        img: {
          desktop: HomeBeacon4D,
          tablet: HomeBeacon4T,
          mobile: HomeBeacon4M,
        },
      },
      {
        title: 'Plutocon Pro',
        desc: '산업용 비콘 단말기',
        link: 'https://orbro.io/beacon/industry',
        img: {
          desktop: HomeBeacon5D,
          tablet: HomeBeacon5T,
          mobile: HomeBeacon5M,
        },
      },
      {
        title: 'ORBRO Tag',
        desc: '소형 비콘 단말기',
        link: 'https://orbro.io/beacon/tag',
        img: {
          desktop: HomeBeacon6D,
          tablet: HomeBeacon6T,
          mobile: HomeBeacon6M,
        },
      },
    ],
  },

  products: {
    title: '정밀한 무선 추적, ORBRO 전파 솔루션',
    desc: 'BLE, UWB, AoA 기술을 통한 실시간 위치 데이터 확보',
    button: '상담 문의',
    buttonLink: 'https://orbro.io/request',
    card: [
      {
        title: 'TwinTracker BLE',
        desc: '저전력 BLE 신호를 기반으로 실내외 자산, 인원, 차량을 경제적으로 추적합니다.',
        link: '/rtls/ble',
        img: {
          desktop: HomeProductBleDesktop,
          tablet: HomeProductBleTablet,
          mobile: HomeProductBleMobile,
        },
      },
      {
        title: 'TwinTracker AoA',
        desc: 'BLE 신호의 입사각(Angle of Arrival)을 계산하여 고정밀 위치 정보를 제공합니다.',
        link: '/rtls/aoa',
        img: {
          desktop: HomeProductAoaDesktop,
          tablet: HomeProductAoaTablet,
          mobile: HomeProductAoaMobile,
        },
      },
      {
        title: 'TwinTracker UWB',
        desc: 'UWB 초광대역 기술로 실시간 고정밀 위치추적을 지원합니다.',
        link: '/rtls/uwb',
        img: {
          desktop: HomeProductUwbDesktop,
          tablet: HomeProductUwbTablet,
          mobile: HomeProductUwbMobile,
        },
      },
      {
        title: 'Comfort Kit',
        desc: '서버 설치 없이 모바일 앱으로 간편하게 사용하는 독립형 BLE 위치추적 시스템입니다.',
        link: '/rtls/comfort',
        img: {
          desktop: HomeProductComfortDesktop,
          tablet: HomeProductComfortTablet,
          mobile: HomeProductComfortMobile,
        },
      },
    ],
  },

  camera: {
    title: '영상 기반 위치추적',
    desc: 'AI 영상 분석 기술을 활용하여 사람, 차량, 객체의 위치를 실시간으로 추적합니다.',
    card: [
      {
        title: 'ORBRO Edge AI',
        desc: '소규모 설치용 Edge 장치 (최대 2대 카메라 지원)',
        link: '/camera/edge',
        img: {
          desktop: HomeProductEdgeDesktop,
          tablet: HomeProductEdgeTablet,
          mobile: HomeProductEdgeMobile,
        },
      },
      {
        title: 'ORBRO AI Server',
        desc: '대규모 다수 카메라 연동 지원 (Enterprise용)',
        link: '/camera/server',
        img: {
          desktop: HomeProductServerDesktop,
          tablet: HomeProductServerTablet,
          mobile: HomeProductServerMobile,
        },
      },
    ],
  },

  solution: {
    title: '공간과 데이터를 연결하는 ORBRO 솔루션',
    desc: '실시간 위치 추적부터 AI 영상 분석까지, ORBRO는 다양한 기술로 고객의 비즈니스 혁신을 지원합니다',
    request: '솔루션 상담 문의',
    card: [
      {
        img: '',
        title: '건설',
        desc: '작업자, 자재, 중장비를 실시간으로 관리하여 건설 현장의 안전성과 효율을 높입니다.',
        link: '/enterprise/construction/safety',
        bgImg: {
          desktop: HomeSolutionPortConstruction,
          tablet: HomeSolutionLandConstruction,
          mobile: HomeSolutionLandConstruction,
        },
      },
      {
        img: '',
        title: '물류',
        desc: '창고 및 물류 재고를 실시간으로 추적하고, 작업자의 안전을 체계적으로 관리합니다.',
        link: '/enterprise/logistics/asset',
        bgImg: {
          desktop: HomeSolutionPortLogistics,
          tablet: HomeSolutionLandLogistics,
          mobile: HomeSolutionLandLogistics,
        },
      },
      {
        img: '',
        title: '제조',
        desc: '생산 공정과 재고를 실시간으로 모니터링하여 제조 현장의 생산성과 품질을 향상시킵니다.',
        link: '/enterprise/manufacturing/process',
        bgImg: {
          desktop: HomeSolutionPortManufacture,
          tablet: HomeSolutionLandManufacture,
          mobile: HomeSolutionLandManufacture,
        },
      },
      {
        img: '',
        title: '병원',
        desc: '환자와 의료 자산을 정확히 추적하고, 의료 폐기물 관리까지 통합 지원합니다.',
        link: '/enterprise/medical/patient',
        bgImg: {
          desktop: HomeSolutionPortMedical,
          tablet: HomeSolutionLandMedical,
          mobile: HomeSolutionLandMedical,
        },
      },
      {
        img: '',
        title: '오피스',
        desc: '사무실 내 자산을 효율적으로 관리하여 업무 환경의 체계성과 안전을 강화합니다.',
        link: '/enterprise/office/asset',
        bgImg: {
          desktop: HomeSolutionPortOffice,
          tablet: HomeSolutionLandOffice,
          mobile: HomeSolutionLandOffice,
        },
      },
      {
        img: '',
        title: '리테일',
        desc: '방문객 데이터를 분석하여 리테일 공간의 운영 효율과 고객 경험을 최적화합니다.',
        link: '/enterprise/retail/exhibition',
        bgImg: {
          desktop: HomeSolutionPortRetail,
          tablet: HomeSolutionLandRetail,
          mobile: HomeSolutionLandRetail,
        },
      },
    ],
  },

  faq: {
    title: '자주 묻는 질문',
    list: [
      {
        q: 'ORBRO 위치추적 솔루션은 실내외 모두 사용할 수 있나요?',
        a: '네. 실내외 모두 가능합니다.\n전파 기반(BLE, UWB, AoA), 영상 기반(AI 분석), GPS 기반(차량 및 야드 단말기)까지 다양한 환경에 대응합니다.',
      },
      {
        q: '전파 기반 위치추적과 영상 기반 위치추적의 차이점은 무엇인가요?',
        a: '전파 기반 위치추적은 BLE, UWB, AoA 같은 무선 신호를 이용하여 정밀한 위치를 계산합니다.\n영상 기반 위치추적은 카메라 영상을 AI로 분석하여 사람, 차량 등의 위치를 실시간으로 추적합니다.\n필요에 따라 두 기술을 함께 적용할 수도 있습니다.',
      },
      {
        q: 'ORBRO 제품을 설치하려면 서버나 별도 장비가 필요한가요?',
        a: '제품에 따라 다릅니다.\nComfort Kit는 별도 서버 없이 모바일 앱만으로 사용 가능합니다.\nTwinTracker BLE, UWB, AoA는 ORBRO Server 또는 Edge 장비와 함께 사용합니다.\n영상 기반 추적(Edge AI, AI Server)은 카메라 설치 및 서버 연동이 필요합니다.',
      },
      {
        q: '소규모 공간에도 설치가 가능한가요?',
        a: '네, 가능합니다. 소규모 사무실, 창고, 임시 현장 등에는 Comfort Kit나 ORBRO Edge AI 솔루션이 적합합니다.\n규모와 환경에 따라 최적의 솔루션을 추천해 드립니다.',
      },
      {
        q: '위치추적 데이터는 어떻게 활용할 수 있나요?',
        a: 'ORBRO OS를 통해 지도 화면에서 실시간 위치를 확인할 수 있으며,\n또한 API를 제공하여 고객 시스템과 연동하거나, 자산 관리, 인원 모니터링, 안전 관리 등에 다양하게 활용할 수 있습니다.',
      },
      {
        q: 'ORBRO 제품은 얼마나 빠르게 설치할 수 있나요?',
        a: 'Comfort Kit는 몇 시간 이내에 바로 사용할 수 있으며,\nTwinTracker 및 영상 기반 시스템은 현장 규모에 따라 수일~수주 내 설치가 가능합니다.',
      },
      {
        q: '데이터를 외부 서버로 보내지 않고 내부망에서만 운영할 수 있나요?',
        a: '네, 가능합니다.\nORBRO Server 또는 AI Server를 로컬 네트워크에 구축하여 외부 인터넷 없이 안전하게 운영할 수 있습니다.',
      },
      {
        q: 'ORBRO 솔루션은 확장성이 있나요?',
        a: '네, 있습니다.\n현장 변화에 따라 추가 센서, 추가 카메라, 시스템 확장이 가능합니다.\n또한 API를 통해 외부 시스템 연동도 유연하게 지원합니다.',
      },
      {
        q: 'ORBRO 솔루션 도입 시 유지보수는 어떻게 진행되나요?',
        a: '초기 설치 후 기본 유지보수 지원이 제공되며,\n필요 시 별도 계약을 통해 정기 점검 및 기술 지원 서비스를 받을 수 있습니다.',
      },
    ],
  },

  //product.ts
  product: {
    items: [
      {
        title: '무선 위치 추적',
        description: '무선 위치 추적을 통한<br/>완벽한 자산관리, 정확한 위치 추적',
        link: '/rtls',
      },

      {
        title: '카메라 위치추적',
        description: `AI기술을 활용한 카메라 위치 추적 시스템`,
        link: '/camera',
      },

      {
        title: '출입 시스템',
        description: '더 빠르게, 더 스마트하게.<br/>새로운 출입 시스템',
        link: '/access',
      },
      {
        title: '산업용 센서',
        description: '화재감지부터, 온습도 까지<br/>바로 현장 적용 가능한 센서',
        link: '/iot/LoRAGateway',
      },
      {
        title: '사물 인터넷',
        description: `단순한 것에서 오는 특별한 변화`,
        link: '/iot/bell',
      },
      {
        title: '비콘 단말기',
        description: '완성형 비콘 시스템',
        link: '/beacon/industry',
      },
    ],
  },

  control: {
    title: `ORBRO를 통한 통합관리`,
    description: `단 하나의 소프트웨어<br/>모바일부터 데스크탑까지 필요한 것들만 심플하게`,
  },

  showMore: '더 알아보기',
};
